import { render, staticRenderFns } from "./note.vue?vue&type=template&id=644aa216&scoped=true"
import script from "./note.vue?vue&type=script&lang=js"
export * from "./note.vue?vue&type=script&lang=js"
import style0 from "./note.vue?vue&type=style&index=0&id=644aa216&prod&lang=scss&scoped=true"
import style1 from "./note.vue?vue&type=style&index=1&id=644aa216&prod&lang=scss&scoped=true"
import style2 from "./note.vue?vue&type=style&index=2&id=644aa216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644aa216",
  null
  
)

export default component.exports